import type { IconData } from '@stacksjs/iconify-core'

export const cloud: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 14a5 5 0 1 1 1.561-9.751A7.002 7.002 0 0 1 20 7a7 7 0 0 1-7 7zm0-2h8a5 5 0 1 0-4.6-6.965l-.72 1.686l-1.742-.572A3 3 0 1 0 5 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cloud
